const JOBS_SEARCH_ENDPOINT = 'job-search/v1.0/search'
const JOBS_DETAIL_ENDPOINT = 'job-search/v1.0/job-detail'
const JOBS_SPECIALS_INFO_ENDPOINT = 'api-gateway/v1.0/special-jobs'
const SAVE_JOB_ENDPOINT = 'api-gateway/v1.0/save-job'
const UN_SAVE_JOB_ENDPOINT = 'api-gateway/v1.0/unsave-job'
const COMPETITIVE_RATE_ENDPOINT = 'api-gateway/v1.0/candidate-report/win-rate'
const VIEW_JOB_ENDPOINT = 'api-gateway/v1.0/user-viewed-job'
const JOB_ENDPOINT = 'api-gateway/v1.0/job'
const INCREASE_JOB_VIEW_ENDPOINT = 'api-gateway/v1.0/increase-view'
const MATCHING_JOB_ENDPOINT = 'api-gateway/v1.0/profile/matching-job'
const UPDATE_JOB_INVITATION_ENDPOINT = 'api-gateway/v1.0/profile/job-invitation'

const SUCCESS_CODE = 200

const retrieveFields = [
    'address',
    'benefits',
    'jobTitle',
    'isSalaryVisible',
    'isShowLogo',
    'companyLogo',
    'userId',
    'jobLevel',
    'jobLevelId',
    'jobLevelVI',
    'jobId',
    'companyId',
    'approvedOn',
    'isAnonymous',
    'alias',
    'expiredOn',
    'industries',
    'workingLocations',
    'services',
    'companyName',
    'onlineOn',
    'simpleServices',
    'visibilityDisplay',
    'isShowLogoInSearch',
    'priorityOrder',
    'skills',
    'profilePublishedSiteMask',
    'salaryMin',
    'salaryMax',
    'prettySalary',
    'jobDescription',
    'jobRequirement'
]

const defauleFilterQuery = {
    query: '',
    filter: [
        {
            field: 'isAnonymous',
            value: 'false'
        }
    ],
    ranges: [],
    order: [
        {
            field: 'approvedOn',
            value: 'desc'
        }
    ],
    hitsPerPage: 4,
    page: 0,
    retrieveFields: retrieveFields,
    exclude: []
}

export {
    JOB_ENDPOINT,
    JOBS_SEARCH_ENDPOINT,
    JOBS_DETAIL_ENDPOINT,
    JOBS_SPECIALS_INFO_ENDPOINT,
    SAVE_JOB_ENDPOINT,
    UN_SAVE_JOB_ENDPOINT,
    COMPETITIVE_RATE_ENDPOINT,
    INCREASE_JOB_VIEW_ENDPOINT,
    MATCHING_JOB_ENDPOINT,
    SUCCESS_CODE,
    VIEW_JOB_ENDPOINT,
    defauleFilterQuery,
    UPDATE_JOB_INVITATION_ENDPOINT
}
